/* =============================================================
   Plek in Bloei — core
   Registratie van modules, levenscyclus en gedeelde helpers.

   Elke module registreert zich met PIB.register(naam, init).
   init(root) wordt aangeroepen bij het laden van de pagina én
   opnieuw wanneer de Shopify Theme Editor een sectie herlaadt.
   Daardoor blijft alles werken tijdens het bewerken.
   ============================================================= */

window.PIB = (function () {
  'use strict';

  var modules = [];
  var kalm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- registratie en levenscyclus ---- */

  function register(naam, init) {
    modules.push({ naam: naam, init: init });
  }

  function boot(root) {
    root = root || document;
    modules.forEach(function (m) {
      try {
        m.init(root);
      } catch (fout) {
        console.error('[PIB] module "' + m.naam + '" faalde:', fout);
      }
    });
  }

  /* ---- gedeelde helpers ---- */

  function eenmalig(el, sleutel) {
    if (el.dataset[sleutel] === 'ja') return false;
    el.dataset[sleutel] = 'ja';
    return true;
  }

  function melden(tekst) {
    var doos = document.querySelector('.melding');
    if (!doos || !tekst) return;
    doos.textContent = tekst;
    doos.classList.add('is-open');
    clearTimeout(doos._timer);
    doos._timer = setTimeout(function () { doos.classList.remove('is-open'); }, 3200);
  }

  function euro(centen) {
    return (centen / 100).toFixed(2).replace('.', ',');
  }

  /* ---- overlays: lade, zoeken, beeldvergroting ---- */

  var laatsteFocus = null;

  function open(id) {
    var paneel = document.getElementById(id);
    if (!paneel) return;

    laatsteFocus = document.activeElement;
    paneel.classList.add('is-open');
    paneel.removeAttribute('aria-hidden');

    var laag = document.querySelector('.sluiterlaag');
    if (laag) laag.classList.add('is-open');
    document.body.classList.add('is-vergrendeld');

    var eerste = paneel.querySelector('input:not([type="hidden"]), button, a[href]');
    if (eerste) setTimeout(function () { eerste.focus(); }, 140);
  }

  function sluit() {
    var open = document.querySelectorAll('.lade.is-open, .zoeklaag.is-open, .vergroting.is-open');
    if (!open.length) return;

    open.forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });

    var laag = document.querySelector('.sluiterlaag');
    if (laag) laag.classList.remove('is-open');
    document.body.classList.remove('is-vergrendeld');

    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus();
    laatsteFocus = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      open(opener.dataset.open);
      return;
    }
    if (e.target.closest('[data-sluiten]') || e.target.classList.contains('sluiterlaag')) {
      e.preventDefault();
      sluit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { sluit(); return; }
    if (e.key !== 'Tab') return;

    var paneel = document.querySelector('.lade.is-open, .zoeklaag.is-open');
    if (!paneel) return;

    var velden = paneel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea');
    if (!velden.length) return;

    var eerste = velden[0];
    var laatste = velden[velden.length - 1];

    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  });

  /* ---- onthullen bij scrollen ---- */

  register('onthullen', function (root) {
    var doelen = root.querySelectorAll('.onthul, .onthul-beeld');
    if (!doelen.length) return;

    if (kalm || !('IntersectionObserver' in window)) {
      doelen.forEach(function (el) { el.classList.add('is-zichtbaar'); });
      return;
    }

    var waarnemer = new IntersectionObserver(function (regels) {
      regels.forEach(function (regel) {
        if (!regel.isIntersecting) return;
        regel.target.classList.add('is-zichtbaar');
        waarnemer.unobserve(regel.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

    doelen.forEach(function (el) {
      if (eenmalig(el, 'onthuld')) waarnemer.observe(el);
    });
  });

  /* ---- opstarten ---- */

  function start() { boot(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme Editor: sectie opnieuw geladen → alleen die sectie opnieuw
     initialiseren. Zonder dit breekt elke interactie in de editor. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });

  return {
    register: register,
    boot: boot,
    open: open,
    sluit: sluit,
    melden: melden,
    euro: euro,
    eenmalig: eenmalig,
    kalm: kalm
  };
})();
